
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/address-details",
      function () {
        return require("private-next-pages/address-details/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/address-details"])
      });
    }
  